import { IconButton, TableCell, TableRow } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { IManualOrderPreviewRow } from "../../Interfaces/manualInterfaces";
import { StepInstrumentType } from "../../Interfaces/stepInterfaces";
import CompactOrderPreviewTable from "../../Components/CompactOrderPreviewTable";
import OrderPreviewInstrument, { PreviewInstrumentHeader } from "../../Components/OrderPreviewInstrument";
import { addComma } from "src/helper";
import Loading from "../../Components/Loading/Loading";

interface IProps {
  values: IManualOrderPreviewRow[] | null | undefined;
  loading?: boolean;
  onRemoveRow?: (userId: number) => void;
}

const PreviewManualOrderTable = ({ values, loading, onRemoveRow }: IProps) => {
  const colCount = 13 + (onRemoveRow ? 1 : 0);

  const getHeader = () => (
    <>
      <TableCell>#</TableCell>
      <TableCell>کاربر</TableCell>
      <TableCell>نوع سهم</TableCell>
      <TableCell><PreviewInstrumentHeader>نماد</PreviewInstrumentHeader></TableCell>
      <TableCell>پلکان اول</TableCell>
      <TableCell>پلکان آخر</TableCell>
      <TableCell>تعداد پلکان</TableCell>
      <TableCell>روش تعیین<br />حجم</TableCell>
      <TableCell>مقدار روش<br />انتخاب شده</TableCell>
      <TableCell>حجم محاسبه<br />شده</TableCell>
      <TableCell>ساعت اجرا</TableCell>
      <TableCell>سرمایه درگیر<br />(مبلغ)</TableCell>
      <TableCell>فروش خودکار<br />صندوق</TableCell>
      {onRemoveRow ? <TableCell /> : null}
    </>
  );

  const getInstrumentType = (type: StepInstrumentType) => {
    switch (type) {
      case StepInstrumentType.Fund:
        return "صندوق";
      case StepInstrumentType.Normal:
        return "عادی";
      case StepInstrumentType.Option:
        return "اختیار";
    }
  };

  const getBody = () => (
    <>
      {loading ? (
        <TableRow className="!relative h-10 !w-full">
          <TableCell
            colSpan={colCount}
            className="!w-full !m-auto !flex !justify-center !items-center !h-full !absolute"
          >
            <Loading className="!text-sky-500" />
          </TableCell>
        </TableRow>
      ) : values?.length ? (
        values.map((row, index) => (
          <TableRow key={row.userId}>
            <TableCell>{index + 1}</TableCell>
            <TableCell>{row.userName}</TableCell>
            <TableCell>{getInstrumentType(row.instrumentType)}</TableCell>
            <TableCell><OrderPreviewInstrument name={row.instrumentName} orderSide={row.orderSide} optionOrderType={row.optionOrderType} instrumentType={row.instrumentType} /></TableCell>
            <TableCell>{addComma(row.firstStepPrice)}</TableCell>
            <TableCell>{addComma(row.lastStepPrice)}</TableCell>
            <TableCell>{row.stepCount}</TableCell>
            <TableCell>{row.volumeCalcMethod}</TableCell>
            <TableCell>{addComma(row.originalVolumeInput)}</TableCell>
            <TableCell>{addComma(row.totalVolume)}</TableCell>
            <TableCell>{row.scheduledExecutionTime || "-"}</TableCell>
            <TableCell>{addComma(row.engagedCapitalAmount)}</TableCell>
            <TableCell>{row.autoSellFund ? <CheckIcon fontSize="small" className="!text-green-600" /> : <CloseIcon fontSize="small" className="!text-red-600" />}</TableCell>
            {onRemoveRow ? (
              <TableCell className="!w-12">
                <IconButton
                  size="small"
                  onClick={() => onRemoveRow(row.userId)}
                  aria-label="remove row"
                >
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </TableCell>
            ) : null}
          </TableRow>
        ))
      ) : (
        <TableRow className="!relative h-10 !w-full">
          <TableCell
            colSpan={colCount}
            className="!w-full !m-auto !flex !justify-center !items-center !h-full !absolute"
          >
            موردی یافت نشد
          </TableCell>
        </TableRow>
      )}
    </>
  );

  return (
    <CompactOrderPreviewTable header={getHeader()} body={getBody()} size="wide" />
  );
};

export default PreviewManualOrderTable;
